import { bl_fi_packing_order_packed_bins_RowClass, bl_fi_packing_order_packed_bins_RowInterface } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class PackingOrderPackedBinsContainerModel extends BaseContainerModel {
  bl_fi_packing_order_packed_bins: bl_fi_packing_order_packed_bins_RowInterface =
    new bl_fi_packing_order_packed_bins_RowClass();
}